import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filter'
})

export class FilterPipe implements PipeTransform {
	transform(items: any[], searchText, element=null): any[] {
		if(!items) return [];
		if(!searchText) return items;

		if (typeof searchText == 'string') {
			searchText = searchText.toLowerCase();
			return items.filter( it => {
				if (element == null)
					return it.toLowerCase().includes(searchText);
				else
					return it[element].toLowerCase().includes(searchText);
			});
		}
		else if (typeof searchText == 'number') {
			return items.filter( it => {
				if (element == null)
					return it == searchText;
				else
					return it[element] == searchText;
			});
		}
	}
}